export const moduleMenu = {
	state() {
		return {
			menu: [
				{
					id: 1,
					label: 'pulpit',
					href: '/Dashboard',
					attributes: {
						slideIndex: 1,
					},
				},
				{
					id: 2,
					label: 'Zasil rachunek FX',
					href: '/Dashboard',
					attributes: { slideIndex: 1 },
				},
				{
					id: 3,
					label: 'Wypłać z rachunku FX',
					href: '/Dashboard',
					attributes: { slideIndex: 2 },
				},
				{
					id: 4,
					label: 'Moje dane i rachunki',
					href: '/Dashboard',
					attributes: { slideIndex: 0 },
				},
				{
					id: 5,
					label: 'warunki handlu',
					subMenuShow: false,
					subMenu: [
						{
							label: 'instrumenty',
							link: '//www.mforex.pl/warunki-handlu',
						},
						{
							label: 'punkty SWAP',
							link: '//www.mforex.pl/warunki-handlu',
						},
						{
							label: 'zabezpieczenia',
							link: '//www.mforex.pl/warunki-handlu',
						},
						{
							label: 'opłaty i prowizje',
							link: '//www.mforex.pl/warunki-handlu',
						},
						{
							label: 'regulaminy',
							link: '//www.mforex.pl/regulaminy',
						},
					],
				},
				{
					id: 6,
					label: 'narzędzia inwestora',
					subMenuShow: false,
					subMenu: [
						{
							label: 'mNews - serwis informacyjny',
							link: '//www.mforex.pl/mnews/#/market',
						},
						{
							label: 'mForex Web',
							link: '//webtrader.mforex.pl/',
						},
						{
							label: 'mForex Trader - MT4 - pobierz',
							link: '//www.mforex.pl/do-pobrania-pliki-instalacyjne',
						},
						{
							label: 'instrukcje obsługi',
							link: '//www.mforex.pl/baza-wiedzy-mforex-trader',
						},
						{
							label: 'klient doświadczony',
							attributes: {
								slideIndex: 1,
							},
							href: '/eLearning',
							link: '/eLearning',
						},
					],
				},
			],

			activeSlide: 0,
		};
	},
	mutations: {
		setMenu(state, data) {
			state.menu = data;
		},
		setSubMenuClosed(state) {
			for (var i = 0, len = state.menu.length; i < len; i++) {
				state.menu[i].subMenuShow = false;
			}
		},
		setActiveSlide(state, data) {
			state.activeSlide = data;
		},
	},
	getters: {
		getMenu: (state) => state.menu,
		getActiveSlide: (state) => state.activeSlide,
	},
	actions: {
		closeSubMenu({ commit }) {
			commit('setSubMenuClosed');
		},
	},
};
